'use strict';

angular.module('accessRequestModule', [
    'ngKomondorResourceView'
]);
